/**
 * Default: Components
 */

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';

import {
	Details,
	TabGroup,
	Tag
} from '@ifabnpm/bootstrap/components.js';

import Button from './shared/button';
import List from './shared/list';
import Form from './shared/form';
import HorizontalRule from './custom/horizontal-rule';
import Player from './shared/player';
import Slider from './shared/slider';
import Table from './shared/table';

const attachLinkIcons = async () => {
	const linkIconAssignments = {
		email: 'email',
		file : 'download',
		web  : 'website'
	};

	for (const [key, icon] of Object.entries(linkIconAssignments)) {
		const links = SelectorEngine.find(`a.link-${key}:not(.link-${key}:has(.svg-icon))`);

		for (const link of links) {
			const linkText = link.textContent;

			link.textContent = '';

			Manipulator.addClass(link, 'link');

			Manipulator.elementAppend(`<span aria-hidden="true" class="link__prefix svg-icon" data-svg-icon>
				<svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
					<use xlink:href="#svg-icon-${icon}"></use>
				</svg>
			</span>`, link);
			Manipulator.elementAppend(`<span class="link__label">${linkText}</span>`, link);
		}
	}
};

// ------
// Public
// ------

const index = () => {
	List.init().then(result => {
		// Do nothing...
	});
	Button.init();
	HorizontalRule.init().then(result => {
		// Do nothing...
	});
	Tag.init();
	Details.init();
	TabGroup.init();
	Slider.init();
	Player.init().then(result => {
		// Do nothing...
	});
	Table.init();
	Form.init();

	attachLinkIcons().then(result => {
		// Do nothing...
	});

	// const gMapAllowed = (typeof window.ifabCookieConsent !== 'undefined') ? window.ifabCookieConsent.getConsent('googlemaps') : true;
	//
	// if (gMapAllowed && typeof window.pageInstance.settings.maps.google.id) {
	//GMap.init(null, {
	//	apiKey  : window.pageInstance.settings.maps.google.id,
	//	settings: {
	//		// Siehe google-maps.js -> DEFAULTS
	//		map: {
	//			zoom: 14
	//		}
	//	}
	//});
	// }
};

// Export
export default index;
